import { render, staticRenderFns } from "./part2check.vue?vue&type=template&id=2a45b60f&scoped=true"
import script from "./part2check.vue?vue&type=script&lang=js"
export * from "./part2check.vue?vue&type=script&lang=js"
import style0 from "./part2check.vue?vue&type=style&index=0&id=2a45b60f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45b60f",
  null
  
)

export default component.exports